import { createDomainStore } from "../_utils/createDomainStore";
import type { Team, TeamId } from "@gs/core/domain/Team/Team";

export const [teamStore, useTeamStore] = createDomainStore<Team, TeamId>("team");
